import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import { render } from "react-dom";

import { Providers } from "./context";

import App from "./pages";

import "./assets/css/style.css";

render(
  <Providers>
    <App />
  </Providers>,
  document.querySelector("#app")
);
